<script setup>
import { ref } from 'vue';
import { useIntervalFn } from '@vueuse/core';

const props = defineProps({
    datetime: {
        required: true,
    },
});

const timeLeftDisplay = ref('_h __m __s');
const { pause } = useIntervalFn(() => {
    const timeLeft = calculateTimeLeft(props.datetime);
    if (timeLeft.isFinished) {
        pause();
    }
    timeLeftDisplay.value = timeLeft.display;
}, 1000);

const calculateTimeLeft = (dateTime) => {
    const now = new Date();
    const target = new Date(dateTime);
    const diff = target - now;
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    const isFinished = diff < 0;

    let display = '';
    if (hours > 0) {
        display += `${hours}h`;
    }
    display += ` ${minutes}m`;
    display += ` ${seconds}s`;

    return {
        display,
        isFinished,
        diff,
        hours,
        minutes,
        seconds,
    };
};
</script>

<template>
    <div class="tabular-nums">{{ timeLeftDisplay }}</div>
</template>
